const NON_DIGIT_REGEX = /\D/g;
const LEADING_ZERO_REGEX = /^0+(?=\d)/g;

/**
 * Estrae solo le cifre da un valore di input (es. '12,34' -> '1234').
 * @param {string|number|null|undefined} value
 * @returns {string} solo cifre oppure stringa vuota
 */
export function extractMoneyDigits(value) {
  if (value === null || value === undefined) {
    return '';
  }

  const digits = String(value).replace(NON_DIGIT_REGEX, '');
  return digits;
}

/**
 * Converte una stringa di cifre (cents) nel formato visuale "1.234,56".
 * @param {string} digits - solo cifre, rappresentano i centesimi (es. '1234' -> €12,34)
 * @returns {string} rappresentazione formattata, '' se non ci sono cifre
 */
export function formatMoneyInput(digits) {
  if (!digits) {
    return '';
  }

  const padded = digits.padStart(3, '0');
  const integerPart = padded.slice(0, -2) || '0';
  const decimalPart = padded.slice(-2);

  const normalizedInteger = integerPart.replace(LEADING_ZERO_REGEX, '') || '0';
  const groupedInteger = normalizedInteger.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${groupedInteger},${decimalPart}`;
}

/**
 * Converte un importo numerico o stringa (es. 12.34 oppure "12,34")
 * in una stringa di soli centesimi (es. '1234').
 * @param {number|string|null|undefined} amount
 * @returns {string} solo cifre oppure stringa vuota
 */
export function amountToMoneyDigits(amount) {
  if (amount === null || amount === undefined) {
    return '';
  }

  if (typeof amount === 'string' && amount.trim() === '') {
    return '';
  }

  const normalized = Number(String(amount).replace(',', '.'));
  if (!Number.isFinite(normalized)) {
    return '';
  }

  const cents = Math.round(normalized * 100);
  return Math.abs(cents).toString();
}

/**
 * Converte una stringa di cifre (centesimi) in numero con due decimali.
 * @param {string} digits
 * @returns {number} importo in euro (float positivo)
 */
export function moneyDigitsToNumber(digits) {
  if (!digits) {
    return 0;
  }

  const sanitized = digits.replace(NON_DIGIT_REGEX, '');

  if (!sanitized) {
    return 0;
  }

  const value = Number(sanitized) / 100;
  return Number.isFinite(value) ? value : 0;
}

